// Module
var code = `<h4>Callout Schedule Update</h4> <h5>View Coverage Map</h5> <ul> <li>Click the "View Coverage" button to check notification coverage</li> <li>View alarm coverage per site</li> </ul> <h5>New Scheduling</h5> <ul> <li>More intuitive shift scheduling</li> <li>Add unlimited shifts for users</li> </ul>`;
// Exports
export default code;